// src/util/getBody.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var getBody_default = function(body, type) {
    switch(type){
        case "json":
            return JSON.stringify(body);
        default:
            return body;
    }
};
// src/util/getContentType.ts
var getContentType_default = function(type) {
    switch(type){
        case "json":
            return "application/json";
        default:
            return "text/plain;charset=UTF-8";
    }
};
// src/util/getHeaders.ts
var getHeaders_default = function(deviceId, token) {
    var headers = {};
    headers["X-RequestPath"] = window.location.href;
    if (token) headers["X-AccessToken"] = token;
    headers["X-BrowserToken"] = deviceId;
    return headers;
};
// src/util/createRequest.ts
function createRequest(request) {
    var action = request.action, body = request.body, _request_type = request.type, type = _request_type === void 0 ? "json" : _request_type, _request_responseType = request.responseType, responseType = _request_responseType === void 0 ? "json" : _request_responseType, method = request.method, config = request.config, user = request.user, client = request.client;
    var headers = getHeaders_default(user.deviceId, user.token);
    var options = {
        method: method,
        headers: headers,
        mode: "cors",
        redirect: "follow"
    };
    if (body && method !== "get" && method !== "head") {
        options.body = getBody_default(body, type);
        options.headers["Content-Type"] = getContentType_default(type);
    }
    var error = {
        code: 418,
        body: void 0,
        ok: false
    };
    return /*#__PURE__*/ _async_to_generator(function() {
        var uri, response, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    uri = action.startsWith("/") ? "".concat(config.api).concat(action) : "".concat(config.api, "/").concat(action);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        client[responseType](uri, options)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        error
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
var createRequest_default = createRequest;
// src/context/FetchContext.ts
import { createContext } from "react";
var FetchContext_default = createContext(void 0);
// src/hooks/useFetchContext.ts
import { useContext } from "react";
var useFetchContext_default = function() {
    return useContext(FetchContext_default);
};
// src/hooks/useConfig.ts
var useConfig_default = function() {
    var fetchContext = useFetchContext_default();
    return fetchContext.config;
};
function get(method, uri, options) {
    return _get.apply(this, arguments);
}
function _get() {
    _get = // src/services/Fetch.ts
    _async_to_generator(function(method, uri, options) {
        var response, result, body, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(uri, options)
                    ];
                case 1:
                    response = _state.sent();
                    result = {
                        code: response.status,
                        ok: response.ok
                    };
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        response[method]()
                    ];
                case 3:
                    body = _state.sent();
                    return [
                        2,
                        _object_spread_props(_object_spread({}, result), {
                            body: body
                        })
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        _object_spread_props(_object_spread({}, result), {
                            body: void 0
                        })
                    ];
            }
        });
    });
    return _get.apply(this, arguments);
}
function json(uri, options) {
    return _json.apply(this, arguments);
}
function _json() {
    _json = _async_to_generator(function(uri, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                get("json", uri, options)
            ];
        });
    });
    return _json.apply(this, arguments);
}
function text(uri, options) {
    return _text.apply(this, arguments);
}
function _text() {
    _text = _async_to_generator(function(uri, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                get("text", uri, options)
            ];
        });
    });
    return _text.apply(this, arguments);
}
function blob(uri, options) {
    return _blob.apply(this, arguments);
}
function _blob() {
    _blob = _async_to_generator(function(uri, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                get("blob", uri, options)
            ];
        });
    });
    return _blob.apply(this, arguments);
}
var Fetch_default = {
    json: json,
    text: text,
    blob: blob
};
// src/hooks/useFetch.ts
var useFetch_default = function() {
    var fetchContext = useFetchContext_default();
    var _fetchContext_client;
    return (_fetchContext_client = fetchContext.client) !== null && _fetchContext_client !== void 0 ? _fetchContext_client : Fetch_default;
};
// src/hooks/useAccessToken.ts
var useAccessToken_default = function() {
    var _fetchContext_user;
    var fetchContext = useFetchContext_default();
    return fetchContext === null || fetchContext === void 0 ? void 0 : (_fetchContext_user = fetchContext.user) === null || _fetchContext_user === void 0 ? void 0 : _fetchContext_user.token;
};
// src/util/uuid.ts
var uuid_default = function() {
    try {
        crypto.randomUUID();
    } catch (e) {}
    return generateUUID();
};
var generateUUID = function() {
    var d = /* @__PURE__ */ new Date().getTime();
    var d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1e3 || 0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 3 | 8).toString(16);
    });
};
// src/util/getDeviceId.ts
var getDeviceId_default = function() {
    var id = localStorage.getItem("id");
    if (id !== null) return id;
    id = uuid_default();
    localStorage.setItem("id", id);
    return id;
};
// src/hooks/useDeviceId.ts
var useDeviceId_default = function() {
    var _fetchContext_user;
    var fetchContext = useFetchContext_default();
    var _fetchContext_user_deviceId;
    return (_fetchContext_user_deviceId = fetchContext === null || fetchContext === void 0 ? void 0 : (_fetchContext_user = fetchContext.user) === null || _fetchContext_user === void 0 ? void 0 : _fetchContext_user.deviceId) !== null && _fetchContext_user_deviceId !== void 0 ? _fetchContext_user_deviceId : getDeviceId_default();
};
// src/hooks/useUser.ts
var useUser_default = function() {
    var token = useAccessToken_default();
    var deviceId = useDeviceId_default();
    return {
        token: token,
        deviceId: deviceId
    };
};
// src/hooks/useDataRequest.ts
function useDataRequest(method) {
    var config = useConfig_default();
    var user = useUser_default();
    var client = useFetch_default();
    return function() {
        var _ref = _async_to_generator(function(action, data) {
            var request, execute;
            return _ts_generator(this, function(_state) {
                request = getRequest(action, data, method);
                execute = createRequest_default(_object_spread_props(_object_spread({}, request), {
                    config: config,
                    user: user,
                    client: client
                }));
                return [
                    2,
                    execute()
                ];
            });
        });
        return function(action, data) {
            return _ref.apply(this, arguments);
        };
    }();
}
var getRequest = function(action, data, method) {
    return {
        method: method,
        body: data,
        action: action
    };
};
var useDataRequest_default = useDataRequest;
// src/hooks/useDelete.ts
function useDelete() {
    return useDataRequest_default("delete");
}
var useDelete_default = useDelete;
// src/hooks/useRequest.ts
import { useEffect, useState } from "react";
function useRequest(request) {
    var config = useConfig_default();
    var user = useUser_default();
    var _useState = _sliced_to_array(useState(false), 2), fetching = _useState[0], setFetching = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), response = _useState1[0], setResponse = _useState1[1];
    var client = useFetch_default();
    useEffect(function() {
        if (fetching || !client) return;
        var fetch2 = function() {
            var _ref = _async_to_generator(function() {
                var execute;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setFetching(true);
                            execute = createRequest_default(_object_spread_props(_object_spread({}, request), {
                                config: config,
                                user: user,
                                client: client
                            }));
                            return [
                                4,
                                execute()
                            ];
                        case 1:
                            setResponse.apply(void 0, [
                                _state.sent()
                            ]);
                            setFetching(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch2() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch2();
    }, [
        request.action,
        request.method
    ]);
    return response;
}
var useRequest_default = useRequest;
// src/hooks/useGet.ts
function useGet(action) {
    var request = {
        method: "get",
        action: action
    };
    var response = useRequest_default(request);
    if (!response) return void 0;
    if (response.code !== 200) return null;
    return response.body;
}
var useGet_default = useGet;
// src/hooks/useGetAsync.ts
function useGetAsync() {
    var method = useDataRequest_default("get");
    return function() {
        var _ref = _async_to_generator(function(action) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    method(action, {})
                ];
            });
        });
        return function(action) {
            return _ref.apply(this, arguments);
        };
    }();
}
var useGetAsync_default = useGetAsync;
// src/hooks/usePost.ts
function usePost() {
    return useDataRequest_default("post");
}
var usePost_default = usePost;
// src/hooks/usePostRequest.ts
import { useLayoutEffect, useRef, useState as useState2 } from "react";
function usePostSync(action, data) {
    var _useState2 = _sliced_to_array(useState2(), 2), response = _useState2[0], setResponse = _useState2[1];
    var _useState21 = _sliced_to_array(useState2(false), 2), posting = _useState21[0], setPosting = _useState21[1];
    var isAPICalledRef = useRef(false);
    var post = usePost_default();
    useLayoutEffect(function() {
        if (posting || response || isAPICalledRef.current) return;
        setPosting(true);
        isAPICalledRef.current = true;
        var register = function() {
            var _ref = _async_to_generator(function() {
                var body;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                post(action, data)
                            ];
                        case 1:
                            body = _state.sent();
                            setResponse(body);
                            return [
                                2
                            ];
                    }
                });
            });
            return function register() {
                return _ref.apply(this, arguments);
            };
        }();
        register();
    }, []);
    return response;
}
var usePostRequest_default = usePostSync;
// src/hooks/usePut.ts
function usePut() {
    return useDataRequest_default("put");
}
var usePut_default = usePut;
// src/services/FetchContextProvider.tsx
import { jsx } from "react/jsx-runtime";
var FetchContextProvider_default = function(props) {
    var children = props.children, context = props.context;
    return /* @__PURE__ */ jsx(FetchContext_default.Provider, {
        value: context,
        children: children
    });
};
export { FetchContextProvider_default as FetchContextProvider, useDelete_default as useDelete, useFetchContext_default as useFetchContext, useGet_default as useGet, useGetAsync_default as useGetAsync, usePost_default as usePost, usePostRequest_default as usePostSync, usePut_default as usePut, useRequest_default as useRequest, uuid_default as uuid };
